import { CatHeading } from '@blocks-react/components/Heading';
import { CustomerAccountHeadingProps } from '../types';

export const CustomerAccountHeading = ({
  children
}: CustomerAccountHeadingProps) => {
  return <CatHeading variant="display-sm">{children}</CatHeading>;
};
